import React, { useState, useEffect } from "react";
import { Link, useHistory } from "react-router-dom";
import appleIcon from "./../imgs/Apple.svg";
import { Form, message, Spin } from "antd";
import OtpInput from "react-otp-input";
import googleIcon from "./../imgs/google.svg";
import { useDispatch } from "react-redux";
import { SEND_VERIFICATION } from "./../graphql/query/auth";
import { STRAPI_PRODUCTION, STRAPI_DEVELOPMENT } from "./../constants/Api";
import { setTokens } from "../redux/actions/auth";
import { SEARCH_PROFILE } from "../graphql/query/profiles";
import { gql, useLazyQuery } from "@apollo/client";
import { registerUser } from "./../utils/helpers/user";
import { isEmpty } from "lodash";

const SignUp = () => {
  const dispatch = useDispatch();
  const history = useHistory();
  const [state, setState] = useState({
    email: "",
    countryCode: "+1",
    number: "",
    password: "",
    confirmPassword: "",
  });
  const [showVerification, setShowVerification] = useState(false);
  const [verificationCode, setVerificationCode] = useState("");
  const [isUserValid, setUserValid] = useState(false);
  const [loader, setLoader] = useState(false);
  const [loading, setLoading] = useState(false);
  const [seconds, setSeconds] = useState(60);
  const [secondfirst, setSecondFirst] = useState(false);
  const [verificationCodeMatch, setVerificationCodeMatch] = useState("");
  const [token, setToken] = useState(null);
  const [isPasswordValid, setIsPasswordValid] = useState(false);
  const [confirmPasswordValid, setConfirmPasswordValid] = useState(false);

  const [getProfileByEmail] = useLazyQuery(gql(SEARCH_PROFILE), {
    fetchPolicy: "cache-and-network",
    onCompleted: (data) => queryCallBackHandler(data),
    onError: (err) => message.error(err),
  });
  const emailRegex =
    /^(([^<>()[\]\\.,;:\s@\"]+(\.[^<>()[\]\\.,;:\s@\"]+)*)|(\".+\"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;

  const [sendVerificationCode] = useLazyQuery(
    gql(SEND_VERIFICATION),
    {
      fetchPolicy: "network-only",
      onCompleted: ({ sendVerificationCode }) => {
        setVerificationCodeMatch(sendVerificationCode.token);
        setLoader(false);
        setShowVerification(true);
        if (seconds === 0) {
          setSeconds(60);
        }
        message.success("Verification code sent your email");
      },
      onError: (error) => {
        setLoader(false);
        setShowVerification(false);
        message.error(error.message);
      },
    }
  );

  const queryCallBackHandler = async ({ searchProfileByEmail }) => {
    if (isEmpty(searchProfileByEmail)) {
      return profileNotAvailable();
    }
    profileAvailable(searchProfileByEmail);
  };

  const emailonChange = (event) => {
    const validate = emailRegex.test(
      String(event.target.value).toLocaleLowerCase()
    );
    if (validate) {
      setState({ ...state, [event.target.name]: event.target.value });
      setUserValid(true);
    } else {
      setUserValid(false);
      setState({ ...state, [event.target.name]: event.target.value });
    }
  };

  const handleValidUser = (event) => {
    const validate = emailRegex.test(
      String(event.target.value).toLocaleLowerCase()
    );

    if (validate) {
      setUserValid(true);
    } else {
      setUserValid(false);
    }
  };

  const profileNotAvailable = async () => {
    await localStorage.setItem("authToken", JSON.stringify(token));
    await localStorage.setItem("accountType", "custom");
    await localStorage.setItem("accessToken", JSON.stringify(token));
    setLoading(false);
    dispatch(
      setTokens({
        authToken: token,
        accessToken: token,
        accountType: "custom",
      })
    );
  };

  const profileAvailable = async (searchProfileByEmail) => {
    await localStorage.setItem('email', searchProfileByEmail[0]?.email)
    await localStorage.setItem('profileId', searchProfileByEmail[0]?.id)
    await localStorage.setItem("authToken", JSON.stringify(token));
    setLoading(false);
    dispatch(
      setTokens({
        authToken: token,
        accessToken: null,
      })
    );
  };
  // console.log(seconds);

  const createUser = async () => {
    setLoader(true);
    let requestBody = {
      email: state.email,
      username: state.email,
      password: state.password,
    };
    let { jwt, user, message, error } = await registerUser(requestBody);
    if (jwt) {
      setToken(jwt);
      await localStorage.setItem("authToken", jwt);
      await localStorage.setItem("accountType", "custom");
      await localStorage.setItem("accessToken", jwt);
      await localStorage.setItem("userId", user?.id.toString());
      await localStorage.setItem("email", user?.email);
      setLoading(false);
      dispatch(
        setTokens({
          authToken: jwt,
          accessToken: token,
          accountType: "custom",
          apolloAuth: jwt,
        })
      );
      getProfileByEmail({email: user?.email})
      history.push("/userdetails");
    }
    if (error) {
      setShowVerification(false);
      setVerificationCode("");
      setVerificationCodeMatch("");
      const {
        messages: [{ message: errorMessage, id }],
      } = message[0];

      setLoader(false);
      if (id === "Auth.form.error.invalid")
        return displayError("Incorrect email or password!");

      if (id === "Auth.form.error.email.taken")
        return displayError("Email Already Taken");

      if (id === "Auth.form.error.blocked") return displayError(errorMessage);
    }
  };
  const ResendVerificationcode = () => {
    if (
      email &&
      password &&
      isUserValid &&
      confirmPassword &&
      isPasswordValid &&
      confirmPasswordValid &&
      isUserValid
    ) {
      setLoader(true);
      setSecondFirst(true);
      if (seconds === 0) {
        setSeconds(60);
      }
      sendVerificationCode({
        variables: {
          email: state.email,
        },
      });
    }
  };

  const displayError = (errorMessage) => {
    message.error(errorMessage);
    localStorage.clear();
  };

  const onSubmit = async (data) => {
    if (
      email &&
      password &&
      isUserValid &&
      confirmPassword &&
      isPasswordValid &&
      confirmPasswordValid &&
      isUserValid
    ) {
      setLoader(true);
      sendVerificationCode({
        variables: {
          email: state.email,
        },
      });
    }
  };


  const handleChangePassword = (event) => {
    if (event.target.value.trim().length >= 7) {
      setState({ ...state, [event.target.name]: event.target.value });
      setIsPasswordValid(true);
    } else {
      setState({ ...state, [event.target.name]: event.target.value });
      setIsPasswordValid(false);
    }
  };
  const handleChangeConfirmPassword = (e) => {
    if (
      e.target.name === "confirmPassword" &&
      state.confirmPassword === password &&
      state.confirmPassword.length > 0
    ) {
      setConfirmPasswordValid(true);
      setState({ ...state, [e.target.name]: e.target.value });
    } else {
      setState({ ...state, [e.target.name]: e.target.value });
      setConfirmPasswordValid(false);
    }
  };

  useEffect(() => {
    if (seconds > 0 && showVerification) {
      setTimeout(() => setSeconds(seconds - 1), 1000);
    } else {
      setSeconds(60)
    }
  }, [seconds, showVerification]);

  useEffect(() => {
    if (state.confirmPassword === password && isPasswordValid) {
      setConfirmPasswordValid(true);
    } else {
      setConfirmPasswordValid(false);
    }
  }, [state.confirmPassword]);

  useEffect(() => {
    if (verificationCode.length === 6) {
      if (verificationCode && verificationCode == verificationCodeMatch) {
        createUser();
      } else {
        message.error("Email Verification code does not match");
        setShowVerification(false);
        setSeconds(60)
        setVerificationCode("");
        setVerificationCodeMatch("");
      }
    }
  }, [verificationCode, verificationCodeMatch]);

  const handleVerification = async (value) => {
    setVerificationCode(value);
  };

  const socialAuth = (provider) => {
    window.location = `${
      process.env.NODE_ENV === "production"
        ? STRAPI_PRODUCTION
        : STRAPI_DEVELOPMENT
    }/connect/${provider}`;
  };

  const { email, password, confirmPassword } = state;

  return (
    <Spin className="loading" spinning={loader}>
      <div className="signup-container">
        <h1 className="headingz">ZOMBIE</h1>

        <div className="card-body">
          <div className="row d-flex sign">
            <h1 className="heading">Sign up</h1>
            <p className="text-center already mt-2">
              Already have an account?{" "}
              <span className="Sign-text">
                <Link to="/login">Sign In</Link>{" "}
              </span>
            </p>
          </div>

          <div className="row justify-content-center signup-with">
            {/* <div className="col-6">
              <button className="apple">
                <img src={appleIcon} alt="" />
                Continue with Apple
              </button>
            </div> */}
            <div className="col-6">
              <button className="google" onClick={() => socialAuth("google")}>
                <img src={googleIcon} alt="" />
                Continue with Google
              </button>
            </div>
          </div>

          <div className="row d-flex line-box">
            <div className="col-5 p-0">
              <span className="line"></span>
            </div>
            <div className="col-1 mr-2">
              <p>or</p>
            </div>
            <div className="col-5 p-0">
              <span className="lines"></span>
            </div>
          </div>
          <div className="content-wrapper">
            <Form className="form" onFinish={() => onSubmit()}>
              <div className="input-field">
                <label>Email address</label>
                {email && !isUserValid ? (
                  <p className="error">Invalid Email</p>
                ) : null}
                <input
                  type="email"
                  placeholder="Email"
                  name="email"
                  value={email}
                  onChange={(event) => emailonChange(event)}
                  onEndEditing={(event) =>
                    handleValidUser(event.nativeEvent.text)
                  }
                />
              </div>
              <div className="input-field">
                <label>Password</label>
                {password && !isPasswordValid ? (
                  <p className="error">Atleast 8 characters</p>
                ) : null}
                <input
                  type="password"
                  placeholder="Password"
                  name="password"
                  value={password}
                  onChange={(event) => handleChangePassword(event)}
                />
              </div>
              <div className="input-field">
                <label>Confirm Password</label>
                {confirmPassword && !confirmPasswordValid ? (
                  <p className="error">Password don't match</p>
                ) : null}
                <input
                  type="password"
                  placeholder="Confirm Password"
                  value={confirmPassword}
                  name="confirmPassword"
                  onChange={(event) => handleChangeConfirmPassword(event)}
                />
              </div>
              {showVerification ? (
                <>
                  {seconds === 0 ? (
                    <p>
                      Verify your identity by typing in the verification code we
                      sent via Email.
                      <a
                        className="resent-text"
                        onClick={ResendVerificationcode}
                      >
                        {" "}
                        Resend code{" "}
                      </a>{" "}
                      in 0:{seconds}
                    </p>
                  ) : (
                    <p>
                      Verify your identity by typing in the verification code we
                      sent via Email.
                      <a
                        className="resent-text"
                      >
                        {" "}
                        Resend code{" "}
                      </a>{" "}
                      in 0:{seconds}
                    </p>
                  )}
                  <OtpInput
                    value={verificationCode}
                    onChange={(otp) => handleVerification(otp)}
                    numInputs={6}
                    className="otp mr-2"
                    isDisabled={seconds === 0 ? true : false }
                    inputStyle={{
                      width: "2.7rem",
                      height: "2.8rem",
                      backgroundColor: "#F0F0F5",
                      border: "none",
                      borderRadius: "0",
                      borderWidth: 1,
                    }}
                  />
                </>
              ) : null}
              {password === confirmPassword && isUserValid ? (
                verificationCode == verificationCodeMatch ? (
                  <div className="signUp pb-4 pt-3">
                    <button className="google">Sign up</button>
                  </div>
                ) : (
                  <div className="signUp pb-4 pt-3">
                    <button className="google" disabled={true}>
                      Sign up
                    </button>
                  </div>
                )
              ) : (
                <div className="signUp pb-4 pt-3">
                  <button className="google" disabled={true}>
                    Sign up
                  </button>
                </div>
              )}
            </Form>
          </div>
          <div className="pt-4 d-flex">
            <p className="bottom-text">
              By signing up, you agree to our{" "}
              <span className="bottom-bold">Terms and Conditions </span> and{" "}
              <span className="bottom-bold"> Privacy Statement </span>
            </p>
          </div>
        </div>
      </div>
    </Spin>
  );
};

export default SignUp;
